import qs from 'qs'
import { useQuery } from 'react-query'
import { getJSON } from '../../../../../common/services/api'
import { ALERTS_QUERY_KEY, ALERTS_URL } from '../constants'
import type { Alert } from '../utils/types'

type UseAlertsListProps = {
  residentId?: string
  status?: string[]
  enabled?: boolean
}

type UseAlertsListReturn = {
  alerts: Alert[]
  isLoading: boolean
  refetch: () => void
}

export const useAlertsList = ({
  residentId,
  status,
  enabled = true
}: UseAlertsListProps = {}): UseAlertsListReturn => {
  const queryParams = qs.stringify(
    {
      ...(residentId && { residentId }),
      ...(status && status.length > 0 && { 'status[]': status })
    },
    { arrayFormat: 'repeat' }
  )

  const url = queryParams ? `${ALERTS_URL}?${queryParams}` : ALERTS_URL

  const { data, isLoading, refetch } = useQuery<{ result: Alert[] }>(
    [ALERTS_QUERY_KEY, residentId, status],
    () => getJSON({ url }),
    { enabled: enabled && !!residentId }
  )

  return {
    alerts: data?.result ?? [],
    isLoading,
    refetch
  }
}
